export const setVisitedPageId = (pageId: string | number) => {
  if (typeof window === 'undefined') return;
  
  const pageIdStr = pageId.toString();
  const visitedIds = localStorage.getItem('visitedPageIds');
  
  if (visitedIds) {
    if (!visitedIds.split(',').includes(pageIdStr)) {
      localStorage.setItem('visitedPageIds', `${visitedIds},${pageIdStr}`);
      // Dispatch custom event for same-tab updates
      window.dispatchEvent(new Event('visitedPagesUpdated'));
    }
  } else {
    localStorage.setItem('visitedPageIds', pageIdStr);
    window.dispatchEvent(new Event('visitedPagesUpdated'));
  }
};

export const isPageVisited = (pageId: string | number): boolean => {
  if (typeof window === 'undefined') return false;
  
  const visitedIds = localStorage.getItem('visitedPageIds');
  const pageIdStr = pageId.toString();
  return visitedIds?.includes(pageIdStr) || false;
};